import { useRef } from "react";
import { createContext, useContext, useMemo } from "react";
import { useLocalStorage } from "./useLocalStorage";
const ClientContext = createContext();

export const ClientProvider = ({ children }) => {
  const clientJson_r = useRef(null);
  const [clientJson_, setClientJson] = useLocalStorage("clientJson", null);

  const setclient_ = (clientJson) => {
    setClientJson(clientJson);
    clientJson_r.current = clientJson;

    console.log("SC");
    console.log(clientJson_);
    console.log(clientJson_r.current);
  };

  //   const setScenario = (scen_uuid) => {

  //   }

  const value = useMemo(
    () => ({
      clientJson_,
      clientJson_r,
      setclient_,
    }),
    [clientJson_]
  );
  return (
    <ClientContext.Provider value={value}>{children}</ClientContext.Provider>
  );
};

export const useClient = () => {
  return useContext(ClientContext);
};
